<template>
  <div class="address-wrapper">
    <h3>我的地址簿</h3>
    <div class="address-list" v-if="list && list.length">
      <div class="addBox"  v-for="(item) in list" :key="item.id"  >
        <p class="infor"><span class="name">{{ item.name }} </span><span class="tel">{{ item.mobile }}</span></p>
        <p class="detailed-address">{{item.province}} {{item.city}} {{item.area}} {{item.address}}</p>
        <dl>
          <dt v-if="item.is_default" >默认地址</dt>
          <dt v-else @click="setDefault(item)" class="clickable">设为默认地址</dt>
          <dd><span class="delete iconfont" @click="removeAddress(item)">&#xe614;</span><span class="edit iconfont" @click="editAddress(item)">&#xe601;</span></dd>
        </dl>
      </div>
      <div class="addBox btn-cls"  @click="addNewAddress()">
        <div class="addNew">
          <span class="iconAdd">+</span>
          <h4>添加新地址</h4>
          <p>预先填写您的邮寄地址，可以为您</p>
          <p>节约付款时间</p>
        </div>
      </div>
    </div>
    <div class="address-empty" v-else>
      <div class="address-empty__tip">
        <div class="icon-wrap">
          <i class="iconfont">&#xe688;</i>
        </div>
        <div class="address-empty__msg">暂无地址</div>
      </div>
      <button class="c-button c-button--primary address-empty__btn" @click="addNewAddress()">添加新地址</button>
    </div>
    <!-- 地址弹窗 -->
    <Dialog :show="dialog" wrapCls="address-dialog" @hide="onCloseDialog">
      <div class="form-header">
        <div class="form-title">{{ addressForm.id ? "编辑地址" : "添加地址"}}</div>
        <div class="form-desc">*号为必填</div>
      </div>
      <VForm class="ms-row" :model="addressForm" :rule="addressFormRules" ref="addressForm">
        <div class="col-xs-12 col-md-6">
          <FormItem prop="name">
            <input type="text" class="c-input c-input--fullwidth" placeholder="* 收货人姓名" v-model="addressForm.name" maxlength="20"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="sex">
            <MultiSelect v-model="addressForm.sex" :options="sexOpts" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="* 称谓"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="mobile">
            <input type="text" class="c-input c-input--fullwidth" placeholder="* 电话号码" v-model="addressForm.mobile" maxlength="11"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="regions">
            <Cascader textField="name" valueField="name" hint="* 所在省市区" extraCls="cascader-cls" :source="districts" v-model="addressForm.regions"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="address">
            <input type="text" class="c-input c-input--fullwidth" placeholder="* 详细地址" maxlength="30" v-model="addressForm.address"/>
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <FormItem prop="zip_code">
            <input type="text" class="c-input c-input--fullwidth" placeholder="邮政编码（选填）" v-model="addressForm.zip_code" maxlength="6" />
          </FormItem>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="default_address_opts float-left clickable" @click="addressForm.is_default=!addressForm.is_default">
            <i class="iconfont">{{addressForm.is_default?'&#xedaf;':'&#xec58;'}}</i>设为默认地址
          </div>
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="save_address_info float-right">
            <button class="btn" @click="saveInfo">{{ addressForm.id ? "编辑地址" : "添加地址"}}</button>
          </div>
        </div>
      </VForm>
    </Dialog> 
  </div>
</template>

<script>
import VForm from "@/components/form/my-form";
import FormItem from "@/components/form/form-item";
import MultiSelect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Cascader from '@/components/Cascader';
import Dialog from '@/components/Dialog';
import districts from '@/assets/data/districts.json';
import types from "@/store/types";
import api from "@/utils/api";

// eslint-disable-next-line no-misleading-character-class
const regEmoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[A9|AE]\u3030|\uA9|\uAE|\u3030/ig;

export default {
  name: "Checkout",
  components: { VForm, FormItem, MultiSelect, Cascader, Dialog },
  data() {
    return {
      list: [],
      districts,
      sexOpts: ['男士', '女士'],
      addressForm: {
        name: "",
        sex: "",
        mobile: "",
        regions: [], // regions: ["北京", "北京市", "其它区"],
        // province: "",
        // city: "",
        // county: "",
        address: "",
        zip_code: "",
        is_default: false
      },
      addressFormRules: {
        name: [{
          required: true, validator(rule, value, callback) {
            if (!value) {
              callback(new Error("请输入收货人姓名"));
            } else if (regEmoji.test(value)) {
              callback(new Error("姓名中包含Emoji字符"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        sex: [{ required: true, message: "请选择称谓", trigger: "blur" }],
        mobile: [{
          required: true, message: "请输入手机号码",
          validator(fieldRule, value, callback) {
            if (!value) {
              callback(new Error("请输入手机号码"));
            } else if (!/^1[3456789]\d{9}$/.test(value)) {
              callback(new Error("请输入正确的手机号码"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        regions: [{
          required: true, message: "请选择所在地区", type: "array",
          validator: (fieldRule, value, callback) => {
            if (value.length != 3) {
              callback(new Error("请选择地址"))
            } else {
              callback();
            }
          }, trigger: "blur"
        }],
        address: [{
          required: true,
          validator(rule, value, callback) {
            if (!value) {
              callback(new Error("请输入详细地址"));
            } else if (regEmoji.test(value)) {
              callback(new Error("详细地址中不能包含Emoji字符"));
            } else {
              callback();
            }
          }, trigger: "blur"
        } ],
        zip_code: [{
          validator(rule, value, callback) {
            if (value && !/^\d+$/.test(value)) {
            console.log(value)
              callback(new Error("邮政编码为数字格式"));
            } else {
              callback();
            }
          }, trigger: "blur"
        }]
      },
      // 
      dialog: false, 
    }
  },
  created() {
    this.loadPage();
  },
  methods: {
    onCloseDialog() {
      this.dialog = false;
    },
    // 加载数据
    loadPage() {
      api[types.ADDRESS_LIST]().then(res => {
        if (res.code == 1) {
          this.list = this.toSort(res.data);
        } else if (res.code != 2) {
          this.$toast({ message: res.message, iconCls: "failure" });
        }
      }).catch(err => {
        console.warn(err);
      });
    },
    toSort(items) {
      return items.sort((a, b) => {
        if (a.is_default < b.is_default) {
          return 1;
        } else if (a.is_default > b.is_default) {
          return -1;
        } else {
          return 0;
        }
      });
    },
    // 重置地址表单
    resetAddressForm() {
      delete this.addressForm.id;
      this.addressForm = { name: "", sex: "", mobile: "", regions: [], detail: "", zip_code: "", is_default: false };
    },
    // 添加地址
    addNewAddress() {
      this.resetAddressForm();
      this.dialog = true;
    },
    // 编辑地址
    editAddress(address) {
      this.resetAddressForm();
      let info = { ...address };
      info.sex = info.sex == 2 ? "男士" : "女士";
      info.regions = [info.province, info.city, info.area];
      delete info.province; delete info.city; delete info.area;
      delete info.created_at; delete info.updated_at;
      this.addressForm = info;
      this.dialog = true;
    },
    // 删除地址
    removeAddress(address) {
      this.$confirm({
        message: "确定要删除该地址吗？",
        showCancel: true
      }).then(() => {
        api[types.ADDRESS_DELETE]({
          id: address.id
        }).then(res => {
          if (res.code == 1) {
            let idx = this.list.findIndex(item => item.id == address.id);
            if (this.list[idx]) {
              this.list.splice(idx, 1);
            }
          } else if (res.code != 2) {
            this.$toast({ message: res.message, iconCls: "failure" });
          }
        }).catch(err => {
          console.warn(err);
        });
      }).catch(() => {});
    },
    // 设为默认地址
    setDefault(address) {
      if (!address.is_default) {
        api[types.ADDRESS_SET_DEFAULT]({
          id: address.id
        }).then(res => {
          if (res.code == 1) {
            this.list.forEach(item => {
              if (item.id == address.id) {
                item.is_default = 1;
              } else {
                item.is_default = 0;
              }
            });
            this.list = this.toSort(this.list);
          } else if (res.code != 2) {
            this.$toast({ message: res.message, iconCls: "failure" });
          }
        }).catch(err => {
          console.warn(err);
        });
      }
    },
    // 保存地址信息
    saveInfo() {
      this.$refs.addressForm.validate().then(isValid => {
        if (isValid) {
          let newArgs = {...this.addressForm};
          newArgs.sex = newArgs.sex == "男士" ? 2 : 1;
          let [province, city, area] = newArgs.regions
          newArgs.province = province;
          newArgs.city = city;
          newArgs.area = area;
          delete newArgs.regions;
          // 
          let xhrPath = types.ADDRESS_ADD;
          newArgs.id && (xhrPath = types.ADDRESS_UPDATE);
          // 
          api[xhrPath](newArgs).then(res => {
            if (res.code == 1) {
              if (newArgs.is_default) {
                this.list.forEach(item => {
                  item.is_default = 0;
                });
              }
              if (newArgs.id) {
                let idx = this.list.findIndex(item => item.id == newArgs.id);
                this.list[idx] = Object.assign(this.list[idx], newArgs);
              } else {
                let addressCopy = {...res.data};
                this.list.push(addressCopy);
              }
              this.list = this.toSort(this.list);
              this.onCloseDialog();
            } else if (res.code != 2) {
              this.$toast({ message: res.message, iconCls: "failure" });
            }
          }).catch(err => {
            console.warn(err);
          });
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .address-wrapper {
    margin:0 auto; width:100%;
    h3 { color:#333333; font-weight:bold; font-size: 1.125rem; padding: 1.6875rem 0 1.25rem 0; display: none; }
    .address-list {
      width: 100%; padding: 0 1rem;
      .addBox {
        width: 100%; padding: 1.25rem; border:0.0625rem solid rgba(223,223,223,1); margin: 0 0 1rem 0; 
        .infor{
          display:flex;
          .name{ margin-right:1.25rem; font-weight:500;color:rgba(0,0,0,1); line-height:1.25rem;font-size: 0.875rem; }
          .tel{font-weight:500;color:rgba(0,0,0,1); line-height:1.25rem;font-size: 0.875rem;}
        }
        .detailed-address{font-family:PingFangSC-Regular,PingFang SC; font-weight:400;color:rgba(87,87,87,1);line-height:1.25rem;}
        dl{
          display:flex;  justify-content:space-between; margin-bottom:0;
          dt{font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(153,153,153,1); line-height:1.25rem;font-size: 0.875rem;}
          dd{
            cursor:pointer;
            .delete{ margin-right:1.375rem; }
          }
        }
        .addNew {
          text-align: center; cursor: pointer; display: flex; justify-content: center; align-items: center;
          .iconAdd { display: inline-block; text-align: center; line-height:0.65rem; width:1rem; height:1rem; font-weight:400; font-size: 1.125rem; border:0.0625rem solid rgba(51,51,51,1);  border-radius: 50%; vertical-align: middle;  color:rgba(51,51,51,1); }
          h4 { font-size: 0.875rem; color: #000; line-height:1.25rem; margin-bottom: 0; margin-left: 0.5rem; }
          p { font-size: 0.875rem; color:#666666; font-weight:200; margin-bottom:0; display: none; }
        }
        &.btn-cls { padding: 0.9375rem; }
      }
    }
    .address-empty {
      padding: 50px 0;
      .address-empty__tip {
        .icon-wrap {
          width: 5rem; height: 5rem; margin: 0 auto; background: rgb(246, 246, 246); border-radius: 50%; text-align: center;
          .iconfont { font-size: 2.25rem; color: rgb(195, 195, 195); line-height: 5rem; }
        }
        .address-empty__msg { font-size: 1.125rem; color: #000; font-weight: 700; text-align: center; margin-top: 1.25rem; }
      }
      .address-empty__btn { display: block; margin: 1.25rem auto 0 auto; }
    }
    // 地址弹窗
    .cascader-cls {
      & /deep/ .cascader-title { padding: 0.875rem 1rem 0.8125rem; line-height: 16px; border: 1px solid #CCCCCC; border-radius: 1.40625rem; }
    }
    ::v-deep .address-dialog {
      .mask { z-index: 11; }
      .dialog-container {
        width: 726px; max-width: 100%; top: unset; bottom: 0; transform: translate(-50%, 0);
        .dialog-header {
          .dialog-close {
            display: flex; justify-content: center; align-items: center;
            .close-icon {
              width: 24px; height: 24px;
              .iconfont { font-size: 22px; color: #2C2C2C; }
            }
          }
        }
        .dialog-body {
          padding: 40px; flex-direction: column;
          .form-header {
            display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;
            .form-title { font-size: 18px; color: #333333; font-weight: 700; }
            .form-desc { font-size: 12px; color: #7C7D7C; }
          }
        }
      }
    }
  }

  @media screen and (min-width: 48em) {
    .address-wrapper {
      h3 { display: block; }
      .address-list {
        display: flex; flex-wrap: wrap; justify-content: flex-start;
        .addBox {
          width: calc((100% - 1.25rem) / 2); margin: 0 1.25rem 1.25rem 0; 
          .addNew {
            display: block;
            p { display: block; }
          }
          &:nth-child(2n) { margin-right: 0; }
          &.btn-cls { display: flex; flex-direction: column; justify-content: center; align-items: center; }
        }
      }
      .address-empty {
        display: flex; justify-content: space-between; align-items: center; padding: 3.125rem 3.125rem 3.125rem 5rem; border: 1px solid #DFDFDF;
        .address-empty__tip {
          display: flex; justify-content: flex-start; align-items: center;
          .address-empty__msg { margin-top: 0; margin-left: 1rem; }
        }
        .address-empty__btn { margin: 0; height: 2.8125rem; }
      }
      ::v-deep .address-dialog {
        .dialog-container {
          bottom: unset; top: 50%; transform: translate(-50%, -50%);
        }
      }
    }
  }
  @media screen and (min-width: 64em) {
    .address-wrapper {
      .address-list {
        .addBox {
          width: calc((100% - 2.5rem) / 3);
          &:nth-child(2n) { margin-right: 1.25rem; }
          &:nth-child(3n) { margin-right: 0; }
        }
      }
    }
  }
</style>